import React, { useState } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import {
  InputChipText,
  InputPhone,
  InputText,
} from '@goodfynd/react-web.lib.forms';
import { usePermissions } from '@hooks/usePermissions';

import { AuthorizedEmailCheck } from '../../../auth/AuthorizedEmailCheck';
import type { OrganizerInfoFormFields } from '../types';
import { emailValidatorZod } from '../validation';

const OrganizerInfo = ({
  control,
  getValues,
}: UseFormReturn<OrganizerInfoFormFields>) => {
  const { isAdmin } = usePermissions();
  const [contactEmail, setContactEmail] = useState(getValues().email);
  // const accountApi = useUserApi();
  // const validateEmail = async (email?: string) => {
  //   if (!email) return false;
  //   try {
  //     await accountApi.accountExists(email);
  //     return true;
  //   } catch (e) {
  //     return false;
  //   }
  // };

  return (
    <div>
      <InputText control={control} label="Contact Title" name="title" />

      <InputText
        control={control}
        label="Contact First Name"
        name="firstName"
      />

      <InputText control={control} label="Contact Last Name" name="lastName" />

      <InputText
        control={control}
        disabled={!isAdmin}
        label="Contact Email"
        name="email"
        onBlur={() => setContactEmail(getValues().email)}
        helperText={
          contactEmail && isAdmin ? (
            <AuthorizedEmailCheck userId={contactEmail} />
          ) : undefined
        }
      />

      <InputPhone control={control} label="Contact Phone Number" name="phone" />

      <InputPhone
        control={control}
        label="Contact Mobile Phone"
        name="phoneMobile"
      />

      <InputChipText
        control={control}
        label="Admin Emails"
        name="adminEmails"
        validator={emailValidatorZod}
        //DISABLING THIS FOR NOW BECAUSE IT IS NOT WORKING
        // validator={
        //   emailValidatorZod.refine(
        //     validateEmail,
        //     'No associated user with this email address'
        //   ) as any
        // }
      />
    </div>
  );
};

export default OrganizerInfo;
